import { lazy } from 'react';
export const LazyExpiredLinkPage = lazy(() => import('./expired-link.page'));
